export default "__VITE_ASSET__BLlz9Msh__"